export default {"src":"/_next/static/media/zero_state_map_illustration.c20244f5.svg","height":189,"width":291,"blurWidth":0,"blurHeight":0};